import React from 'react';
import {withRouter} from 'react-router-dom';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

class Navigation extends React.Component{
    
    constructor(props){
        super(props);
        this.state = {
            text_search: ''
        }
    }


    handleInputChange = (e) =>{
        this.setState({
            text_search : e.target.value
        });
    }
    handleSubmitForm = (e) =>{
        e.preventDefault();
        if(this.state.text_search){
            this.props.history.push(`/buscar/${this.state.text_search}`);
        }
        
    }
    cerrarSesion=()=>{
        cookies.remove('id',  {path: "/"});
        cookies.remove('name',  {path: "/"});
        cookies.remove('last_name',  {path: "/"});
        cookies.remove('pais',  {path: "/"});
        cookies.remove('address',  {path: "/"});
        cookies.remove('distrito',  {path: "/"});
        cookies.remove('doc_number',  {path: "/"});
        cookies.remove('phone_number',  {path: "/"});
        cookies.remove('url_photo', {path: "/"});
        cookies.remove('email', {path: "/"});
        window.location.href="/";
    }

  
    
    render(){
          
        return(
            <header className="fixed-top navbar navbar-expand-md navbar-light bg-gray" >
                <a className="navbar-brand" href="/">
                    <img width="20" src="/assets/logo.png" className="logo" alt="Arquiproductos"/>
                </a>
                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarCollapse">
                    <ul className="navbar-nav mr-auto px-5">
                        <li className="nav-item">
                            <a href="/empresas" className="nav-link">Empresas</a>
                        </li>
                        <li className="nav-item">
                            <a href="/productos" className="nav-link">Productos<span className="sr-only">(current)</span></a>
                        </li>
                        <li className="nav-item">
                            <a href="/noticias" className="nav-link">Noticias</a>
                        </li>
                        

                        {/* <li className="nav-item dropdown">
                            <a className="nav-link dropdown-toggle" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">
                                <i className="fas fa-plus-circle"></i> Más
                            </a>
                            <div className="dropdown-menu">
                                <a href="#"  className="dropdown-item">Submenu</a>
                            </div>
                        </li> */}

                        <li className="nav-item">
                            <a href="/publicidad" className="nav-link">Publicidad</a>
                        </li>
                        <li className="nav-item">
                            <a href="/videos" className="nav-link">Videos</a>
                        </li>
                        <li className="nav-item">
                            <a href="/contacto" className="nav-link">Contacto</a>
                        </li>

                        <li className="nav-item">
                            <a href="/bim" className="nav-link"><span  className="nav-bim">BIM</span></a>
                        </li>
                    </ul>
                    
                    <form action="#" onSubmit={this.handleSubmitForm} method="POST" className="form-inline w-100 px-2">
                        <div className="input-group w-100">
                            <input type="text" className="form-control" onChange={this.handleInputChange} name="text_search" id="busca" placeholder="Busca entre categorías, empresas, productos y posts" aria-label="buscador" aria-describedby="searcher"/>
                            <div className="input-group-append">
                                <button type="submit" className="btn btn-outline-dark" id="searcher"><i className="fas fa-search"></i></button>
                            </div>
                        </div>
                    </form>

                    <ul className="navbar-nav flex-shrink-1 px-2">
                    <li className="nav-item card_li"><a className="btn btn-sm" href="/shoppingcart"><img className="card_logo"  src="/assets/car.png"></img> <span className="card_cant"  id="total_product">{localStorage.getItem("total_car")!=null?localStorage.getItem("total_car"):0}</span></a></li>
                    </ul>

                    <ul className="navbar-nav flex-shrink-1 px-2">
                    {cookies.get('id')?
                   
                    <div className="btn-group">
                        <a className=" dropdown-toggle btn-menu-user" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        &nbsp;{cookies.get('url_photo')!="null" ? <img src={cookies.get("url_photo")} width="33px" style={{borderRadius:"50%"}}></img> : <img src="/assets/profile-default.png" width="33px" style={{borderRadius:"50%"}}></img> }  Hola, <span>{cookies.get('name')}</span>&nbsp; 
                        </a>
                        <div className="dropdown-menu dropdown-menu-right d_perfil">
                            <div className="perfil">
                            <div className="img">
                                    {cookies.get('url_photo')!="null" ?
                                            <img src={cookies.get("url_photo")} width="100%"></img>
                                            :
                                            <img src="/assets/profile-default.png" width="100%"></img>
                                    }
                                </div>
                                <div className="texto">
                                    <p>{cookies.get('name')} {cookies.get('last_name')} </p>
                                    <p>{cookies.get('email')}</p>
                                </div>

                            </div>
                            <hr></hr>
                            <a href="/user/perfil" className="dropdown-item" >Tu cuenta</a>
                            <a href="/user/pedidos" className="dropdown-item" >Pedidos</a>
                           {/** <a className="dropdown-item" >Mi lista de deseos</a>
                            <a className="dropdown-item" >Mis Listas</a> */}
                            <a className="dropdown-item" onClick={()=>this.cerrarSesion()}>Cerrar sesión</a>
                        </div>
                    </div>
                    :
                    <li className="nav-item"><a className="btn btn-sm cerrar-a" href="/login">Iniciar Sesión</a></li>
                    
                    }
                    </ul>

                    {/* <ul className="navbar-nav flex-shrink-1 px-2">
                        <li className="nav-item"><a className="btn btn-sm" href="#"><i className="fas fa-user-plus"></i> <span className="d-inline d-sm-none">Registrarse</span></a></li>
                        <li className="nav-item"><a className="btn btn-sm" href="#"><i className="fas fa-user-circle"></i> <span className="d-inline d-sm-none">Iniciar sesión</span></a></li>
                    </ul> */}
                </div>

                 
                
                                
            </header>
        )
   

    }
}

export default withRouter(Navigation);